import React from 'react';
export function GuaranteeSection() {
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border relative" data-id="element-114">
      <div className="absolute inset-0 bg-gradient-to-b from-brand-accent/5 via-brand-accent/10 to-brand-accent/5 pointer-events-none" data-id="element-115"></div>
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-116">
        <div className="flex justify-center mb-8" data-id="element-117">
          <div className="bg-brand-accent/10 border border-brand-accent/20 p-5 rounded-full text-5xl" data-id="element-118">
            🛡️
          </div>
        </div>
        <h2 className="text-3xl md:text-4xl font-heading font-bold mb-8 text-white" data-id="element-119">
          GARANZIA TOTALE — 7 GIORNI
        </h2>
        <div className="text-lg md:text-xl space-y-6 max-w-2xl mx-auto" data-id="element-120">
          <p className="text-white/70 bg-brand-card p-5 rounded-2xl border border-brand-border" data-id="element-121">
            Scarica tutto. Sfoglia i volumi. Prova ad usare una lezione o una
            verifica in classe.
          </p>
          <p className="font-bold text-2xl text-white mt-8" data-id="element-122">
            Se per qualsiasi motivo senti che Fisica Pronta non ti fa
            risparmiare tempo o non migliora le tue lezioni:
          </p>
          <div className="py-4" data-id="element-123">
            <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="text-3xl md:text-4xl font-heading font-black text-brand-dark bg-brand-accent inline-block px-8 py-3 rounded-xl transform -rotate-1 cursor-pointer hover:scale-105 transition-transform" data-id="element-124">
              Ti rimborsiamo il 100%.
            </button>
          </div>
          <p className="font-bold text-xl text-white/80" data-id="element-125">
            Senza domande. Scrivici un'email e ti rimborsiamo fino all'ultimo
            centesimo.
          </p>
          <p className="text-white/70 italic" data-id="element-126">
            La fiducia che abbiamo in Fisica Pronta ci permette di offrirti
            questo.
          </p>
        </div>
      </div>
    </section>;
}